import { Api } from "@/networking";
import { ChannelType, ICampaignType } from "@/types";

export const getChannelsAPI = () => {
  return Api.GET_CHANNELS<ChannelType[]>("");
};

export const getChannelDetailsAPI = (id: number) => {
  return Api.GET_CHANNEL_DETAILS<ChannelType>("", {
    urlParams: {
      id,
    },
  });
};

export const createChannelAPI = (data: ChannelType) => {
  return Api.CREATE_CHANNEL<{}>("", {
    data,
  });
};

export const updateChannelAPI = (data: ChannelType) => {
  const { id, ...rest } = data;

  return Api.UPDATE_CHANNEL<{}>("", {
    urlParams: {
      id,
    },
    data: rest,
  });
};

export const deleteChannelAPI = (id: number) => {
  return Api.DELETE_CHANNEL<{}>("", {
    urlParams: {
      id,
    },
  });
};

export const getCampaignTypesAPI = () => {
  return Api.GET_CAMPAIGN_TYPES<ICampaignType[]>("");
};

export const getCampaignTypeDetailsAPI = (id: number) => {
  return Api.GET_CAMPAIGN_TYPE_DETAILS<ICampaignType>("", {
    urlParams: {
      id,
    },
  });
};

export const createCampaignTypeAPI = (data: ICampaignType) => {
  return Api.CREATE_CAMPAIGN_TYPE<{}>("", {
    data,
  });
};

export const updateCampaignTypeAPI = (data: ICampaignType) => {
  const { id, ...rest } = data;

  return Api.UPDATE_CAMPAIGN_TYPE<{}>("", {
    urlParams: {
      id,
    },
    data: rest,
  });
};

export const deleteCampaignTypeAPI = (id: number) => {
  return Api.DELETE_CAMPAIGN_TYPE<{}>("", {
    urlParams: {
      id,
    },
  });
};
